import { Box, Flex, Text } from "@chakra-ui/react";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyledProfileAvatar } from "./style";
import { useGlobalContext } from "@root/context/global-context";
import ArrowIcon from "@root/assets/icons/arrowicon";
import ChangePasswordModal from "@root/components/change-password/change-password";
import PasswordChangedModal from "@root/components/change-password/password-success";
import { LogoutModal } from "@root/components/logout/logout";
import { useNavigate } from "react-router-dom";
import { logout } from "@root/store/thunks";
import { ROUTE_NAMES } from "@root/constants";
import { PopoverDropdown } from "@root/components/common/dropdown";
import EditIcon from "@root/assets/icons/pencil";
import { useTranslation } from "react-i18next";

export function NavControl({
  isMenuOpen,
  setIsMenuOpen,
  changePassword,
  setChangePassword,
  logoutPopup,
  setLogoutPopup,
}: any) {
  const user: any = useSelector(getLoggedInUser);
  console.log("user :: ", user);
  const { isSidebarOpen } = useGlobalContext();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const logoutHandler = () => {
    dispatch(logout({}));
    navigate(ROUTE_NAMES.LOGIN);
  };

  // Hardcoded menu items
  const popoverItems = [
    {
      id: "change-password",
      startIcon: (
        <EditIcon
          width={16}
          height={16}
          fill="#374151"
          style={{ width: "16px", height: "16px" }}
        />
      ),
      text: t("sidebar.changePassword"),
      onClick: () => setChangePassword(true),
    },
    {
      id: "logout",
      startIcon: (
        <Box
          width="16px"
          height="16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <ArrowIcon width={16} height={16} />
        </Box>
      ),
      text: t("sideMenu.Logout"),
      onClick: () => {
        setLogoutPopup(true);
      },
    },
  ];

  return (
    <Flex
      {...(!isSidebarOpen ? { alignItems: "center" } : {})}
      mx={!isSidebarOpen ? "12px" : "0px"}
      gap="16px"
      flexDir="column"
      padding={isSidebarOpen ? "2px" : "6px 0px"}
      borderRadius="16px"
    >
      <PopoverDropdown
        items={popoverItems}
        isOpen={isMenuOpen}
        onOpen={() => setIsMenuOpen(true)}
        onClose={() => setIsMenuOpen(false)}
        placement={isSidebarOpen ? "top-end" : "top"}
        minWidth="180px"
        maxWidth="220px"
      >
        <Box
          cursor="pointer"
          onClick={() => setIsMenuOpen((prev: boolean) => !prev)}
        >
          {isSidebarOpen ? (
            <Flex gap="10px" alignItems="center" justifyContent="space-between">
              {/* Profile avatar + user info */}
              <Flex gap="10px" alignItems="center">
                <StyledProfileAvatar
                  userSelect="none"
                  name={user?.fullname}
                  src={user?.avatar}
                />

                <Box>
                  <Text textColor="#111827" fontWeight="700" fontSize="16px">
                    {user?.fullname || ""}
                  </Text>
                </Box>
              </Flex>

              {/* Arrow icon */}
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  setLogoutPopup(true);
                }}
                cursor="pointer"
              >
                <ArrowIcon />
              </Box>
            </Flex>
          ) : (
            <StyledProfileAvatar
              userSelect="none"
              name={user?.fullname}
              src={user?.avatar}
            />
          )}
        </Box>
      </PopoverDropdown>

      <ChangePasswordModal
        isOpen={changePassword}
        onClose={() => setChangePassword(false)}
        onSuccess={() => setIsSuccessModalOpen(true)}
      />
      <PasswordChangedModal
        isOpen={isSuccessModalOpen}
        onClose={() => {
          setIsSuccessModalOpen(false);
          logoutHandler();
        }}
      />
      <LogoutModal
        isOpen={logoutPopup}
        onClose={() => setLogoutPopup(false)}
        onConfirm={logoutHandler}
      />
    </Flex>
  );
}
